// Promises must be loaded for webpack's import to work. So this must remain unaltered
import Promise from "es6-promise";

// We only want to load the polyfill when it is not already available
if (!("Promise" in window)) {
    window.Promise = Promise;
} else if (!("finally" in window.Promise.prototype)) {
    // some browsers doesn't have .finally
    window.Promise.prototype.finally = Promise.prototype.finally;
}
